import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from '../../../services/authentication.service';
import {first} from 'rxjs/operators';
import {Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Utils} from '../../../services/utils';

@Component({
  selector: 'app-update-security-questions',
  templateUrl: './update-security-questions.component.html',
  styleUrls: ['./update-security-questions.component.css']
})
export class UpdateSecurityQuestionsComponent implements OnInit {

  title;
  username;
  userSecurityQuestions = [];
  errorMessage = '';
  showCheckBox = false;
  isAnswer = false;
  securityQuestionsForm: FormGroup = new FormGroup({});
  submit = false;
  selectedQuestions = [];
  formControlNameList = [];
  token = '';

  get formData() { return this.securityQuestionsForm.controls; }

  constructor(private authService: AuthenticationService, private router: Router, private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.username = history.state.username;

    if (history.state.isAnswer == undefined) {
      // se deu refresh na pagina, perco o histórico... portanto, devo retornar para o login.
      this.onBack();
      return;
    } else {
      this.isAnswer = history.state.isAnswer;
    }

    if (this.isAnswer) {
      this.title = 'Por favor, responda as perguntas de segurança abaixo para continuar';
      this.loadPage(this.username);
    } else {
      if (history.state.token !== undefined) {
        this.token = history.state.token;
      }
      this.title = 'Por favor, selecione e responda a 3 perguntas dentre as listadas abaixo';
      this.loadPage();
    }
  }

  loadPage(login = '') {
    this.authService.getUserSecurityQuestions(login, this.token)
      .pipe(first())
      .subscribe(
        data => {
          this.userSecurityQuestions = data.map(m => ({ id: m.id, question: m.question }));
          this.userSecurityQuestions.forEach(x => {
            let formControlName = `question${x.id}`;

            this.securityQuestionsForm.addControl(formControlName, new FormControl('', [ Validators.maxLength(150) ]));
            this.formControlNameList.push(formControlName);

            if (login !== '') {
              this.securityQuestionsForm.get(formControlName).setValidators([ Validators.required ]);
            } else {
              this.securityQuestionsForm.get(formControlName).disable();
            }
          });

          this.showCheckBox = false;
        },
        error => {
          this.errorMessage = error;
        });
  }

  selectQuestion(selected, formControlName) {
    if (selected.target.checked && this.selectedQuestions.length <= 3) {
      this.securityQuestionsForm.get(formControlName).setValidators([Validators.required, Validators.maxLength(150)]);
      this.securityQuestionsForm.get(formControlName).enable();

      this.selectedQuestions.push(formControlName);
    } else {
      this.securityQuestionsForm.get(formControlName).clearValidators();
      this.securityQuestionsForm.get(formControlName).disable();
      this.securityQuestionsForm.get(formControlName).setValue('');

      this.selectedQuestions = this.selectedQuestions.filter(f => f !== formControlName);
    }

    let unselectedFormControl = this.formControlNameList.filter(f => this.selectedQuestions.indexOf(f) == -1);
    unselectedFormControl.forEach(item => {
      const chk = <HTMLInputElement>document.getElementById(item);
      chk.disabled = this.selectedQuestions.length == 3;
    });

    this.securityQuestionsForm.updateValueAndValidity();
  }

  onSave() {
    this.submit = true;
    let frontFilter = this.securityQuestionsForm.getRawValue();
    let result: { answer: string, questionId: number }[] = [];

    if (this.isAnswer) {
      // esqueci minha senha
      this.userSecurityQuestions.forEach(q => {
        result.push({ answer: frontFilter[`question${q.id}`], questionId: q.id });
      });

    } else {
      // cadastrar perguntas
      let answers = this.userSecurityQuestions.filter(f => this.selectedQuestions.indexOf(`question${f.id}`) !== -1);
      answers.forEach(q => {
        result.push({ answer: frontFilter[`question${q.id}`], questionId: q.id })
      })
    }

    let login = this.username || '';

    this.authService.saveQuestions(result, login, this.isAnswer, this.userSecurityQuestions, this.token)
      .pipe(first())
      .subscribe(data => {
        if (data) {
          this.router.navigate(['/changeTempPassword'],
            { state: { changeTempPassLogin: this.username, loginHandleAnswerQuiz: data['token'] } });
        } else {
          this.router.navigate(['/changeTempPassword'],
            { state: { changeTempPassLogin: this.username, loginHandleAnswerQuiz: '' } });
        }
      }, error1 => {
        this.errorMessage = error1;
      });
  }

  adjustSpaces(value, formControlName) {
    Utils.adjustSpaces(value, this.securityQuestionsForm, formControlName);
  }

  onBack() {
    this.router.navigate(['/login']);
  }

}
